export function isNoEdit(noEdit: string[] | undefined, path: string): boolean {
  return Array.isArray(noEdit) && noEdit.includes(path);
}

export function storedPartnerId(partnerId: unknown): string | undefined {
  if (typeof partnerId === "string" && partnerId) return partnerId;
  if (partnerId && typeof partnerId === "object" && "_id" in partnerId) {
    const id = (partnerId as { _id?: unknown })._id;
    return typeof id === "string" && id ? id : undefined;
  }
  return undefined;
}

export const PARTNER_REMAP_HINT =
  "Unmap the partner in Sensitive Actions, then map a new partner here.";

/** A stored partner cannot be swapped here — empty `noEdit` is not permission
 *  to remap. Unmap is Sensitive Actions only. */
export function isPartnerRemapLocked(
  business?: { partnerId?: unknown; noEdit?: string[] } | null
): boolean {
  return (
    Boolean(storedPartnerId(business?.partnerId)) ||
    isNoEdit(business?.noEdit, "partnerId")
  );
}

export type AdyenSubmissionSource = {
  isSubmittedToAdyen?: boolean;
  noEdit?: string[];
  adyen?: { splitConfigurationId?: string };
};

/** Live on Adyen: the read says so, a split config exists, or the read froze
 *  partner / online fees. `adyen.onboardingStatus` is not this — the read fills
 *  it with "onboardingAllowed" for merchants that have never been submitted. */
export function isMerchantSubmittedToAdyen(
  business: AdyenSubmissionSource | null | undefined
): boolean {
  return (
    business?.isSubmittedToAdyen === true ||
    isNoEdit(business?.noEdit, "partnerId") ||
    isNoEdit(business?.noEdit, "onlineMerchantServiceChargeFees") ||
    Boolean(business?.adyen?.splitConfigurationId)
  );
}
